import React, { forwardRef } from 'react'
import MaskedInput from 'react-text-mask';

const InputPhone = forwardRef((props, ref) => {
  return (
    <MaskedInput
      {...props}
      ref={ref}
      className={'phone_input ' + props.className}
      mask={
        ['(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      }
      placeholder='(000) 000-0000'
    />
  )
});

export default InputPhone;
